import { render, staticRenderFns } from "./ChartPoint.vue?vue&type=template&id=6077bbf2&scoped=true&"
import script from "./ChartPoint.vue?vue&type=script&lang=ts&"
export * from "./ChartPoint.vue?vue&type=script&lang=ts&"
import style0 from "./ChartPoint.vue?vue&type=style&index=0&id=6077bbf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077bbf2",
  null
  
)

export default component.exports